import { UtensilsCrossed } from 'lucide-react'
import { ITheme, Language } from '@/lib/interfaces/interfaces'
import { NextFont } from 'next/dist/compiled/@next/font'

// Copy del estado "menú vacío" de la pública en los 6 idiomas de datos del
// menú (no va en messages/: la pública está fuera del árbol locale y el
// idioma lo da el segmento `language` de la URL, como TITLES_BY_LANG).
export const EMPTY_MENU_TITLE_BY_LANG: Record<Language, string> = {
  es: 'Carta en preparación',
  en: 'Menu in preparation',
  fr: 'Menu en préparation',
  ca: 'Carta en preparació',
  de: 'Speisekarte in Vorbereitung',
  eu: 'Menua prestatzen'
}

export const EMPTY_MENU_DESCRIPTION_BY_LANG: Record<Language, string> = {
  es: 'Este menú aún no tiene productos. Vuelve pronto.',
  en: 'This menu has no products yet. Please check back soon.',
  fr: 'Ce menu ne contient encore aucun produit. Revenez bientôt.',
  ca: 'Aquest menú encara no té cap producte. Torna aviat.',
  de: 'Diese Speisekarte enthält noch keine Produkte. Schauen Sie bald wieder vorbei.',
  eu: 'Menu honek oraindik ez du produkturik. Itzuli laster.'
}

interface Props {
  theme: ITheme
  fontStyle: {
    fontFamily: NextFont
    fontSize: string
  }
  language: Language
}

// Placeholder de "menú vacío" con el theme actual del bar. A propósito NO
// tiene apariencia de sección de items (sin cabecera de sección ni lista):
// es una tarjeta con borde discontinuo, icono y texto centrados. Se usa en
// ambas variantes (classic y modern) cuando la carta visible está vacía.
// Los colores vienen del theme (hex dinámicos), así que van inline.
const EmptyMenuSection = ({ theme, fontStyle, language }: Props) => {
  return (
    <div
      id='carta-vacia'
      className='section'
      style={{ backgroundColor: theme.sectionBgColor }}
    >
      <div
        style={{
          border: `2px dashed ${theme.items.dividerColor}`,
          borderRadius: '8px',
          padding: '36px 24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: '12px'
        }}
      >
        <span
          aria-hidden
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            backgroundColor: theme.items.dividerColor,
            color: theme.items.nameColor
          }}
        >
          <UtensilsCrossed size={28} strokeWidth={1.75} />
        </span>
        <p
          style={{
            margin: 0,
            fontSize: '1.4rem',
            fontWeight: 700,
            color: theme.items.nameColor
          }}
          className={fontStyle.fontFamily.className}
        >
          {EMPTY_MENU_TITLE_BY_LANG[language] ?? EMPTY_MENU_TITLE_BY_LANG.es}
        </p>
        <p
          style={{
            margin: 0,
            maxWidth: '380px',
            fontSize: fontStyle.fontSize,
            color: theme.items.descriptionColor
          }}
          className={fontStyle.fontFamily.className}
        >
          {EMPTY_MENU_DESCRIPTION_BY_LANG[language] ?? EMPTY_MENU_DESCRIPTION_BY_LANG.es}
        </p>
      </div>
    </div>
  )
}

export default EmptyMenuSection
